import splitRoomString from './split-room-string';

export const getRoomStayCandidatesList = paxInfoData => {
  let list = [];
  if (paxInfoData.room == 1) {
    let obj = {
      adultCount: paxInfoData.adults,
      childAges: paxInfoData.agesArray,
    };
    list.push(obj);
  } else {
    divideAdultsInRooms(paxInfoData.adults, paxInfoData.room, list);
    divideChildrenInRooms(
      paxInfoData.agesArray.length,
      paxInfoData.room,
      paxInfoData.agesArray,
      list,
    );
  }
  list.forEach(item => {
    if (!Array.isArray(item.childAges) && !item.childAges) {
      delete item.childAges;
    }
  });
  return list;
};

export const divideAdultsInRooms = (adults, rooms, list = []) => {
  if (rooms < 1 || adults < rooms) {
    return;
  } else {
    let adultCountForRoom = Math.ceil(adults / rooms);
    let obj = {
      adultCount: adultCountForRoom,
      childAges: null,
    };
    list.push(obj);
    divideAdultsInRooms(adults - adultCountForRoom, rooms - 1, list);
  }
};

export const divideChildrenInRooms = (childrenCount, roomCount, childAgeList = [], list = []) => {
  if (roomCount < 1 || childrenCount < 1) {
    return;
  }
  if (childrenCount <= roomCount * 2) {
    let len = childrenCount / 2;
    // for (roomNumber in 0 until childrenCount / 2) {
    for (let roomNumber = 0; roomNumber < len; roomNumber++) {
      addChildInRooms(roomNumber, childAgeList.slice(roomNumber * 2, (roomNumber + 1) * 2), list);
    }
    if (childrenCount % 2 != 0) {
      addChildInRooms(
        childrenCount / 2,
        childAgeList.slice(childAgeList.length - 1, childAgeList.length),
        list,
      );
    }
    return;
  } else {
    var extraChildrenCount = childrenCount - roomCount * 2;
    var childAgeIndex = 0;
    // for (roomNumber in list.indices) {
    for (let roomNumber = 0; roomNumber < list.length; roomNumber++) {
      if (extraChildrenCount < 1) {
        addChildInRooms(roomNumber, childAgeList.slice(childAgeIndex, childAgeIndex + 2), list);
        childAgeIndex += 2;
      } else if (extraChildrenCount == 1) {
        addChildInRooms(roomNumber, childAgeList.slice(childAgeIndex, childAgeIndex + 3), list);
        childAgeIndex += 3;
        extraChildrenCount -= 1;
      } else {
        addChildInRooms(roomNumber, childAgeList.slice(childAgeIndex, childAgeIndex + 4), list);
        childAgeIndex += 4;
        extraChildrenCount -= 2;
      }
    }
  }
};

export const addChildInRooms = (roomNumber, childAgeList = [], list = []) => {
  if (list[roomNumber] && childAgeList) {
    list[roomNumber]['childAges'] = childAgeList;
  }
};

export const prepareRoomStayCandidatesCG = roomStayQualifier => {
  let roomStayCandidatesList = [];
  if (roomStayQualifier) {
    const {paxCount, childAgeArray, roomCount} = splitRoomString(roomStayQualifier);
    roomStayCandidatesList = getRoomStayCandidatesList({
      adults: paxCount,
      room: roomCount,
      agesArray: childAgeArray,
    });
  }
  return roomStayCandidatesList;
};
